export default __webpack_public_path__ + "static/media/capricorn.497c4364.png";